import { apiFetch } from './http';

/** A project's read-only share link (apps/api projects/shares). */
export interface ShareLink {
  token: string;
  createdAt: number;
}

const path = (projectId: string): string => `/projects/${encodeURIComponent(projectId)}/share`;

export const shares = {
  /** The project's active link, or null. */
  get: (projectId: string) =>
    apiFetch<{ share: ShareLink | null }>(path(projectId)).then((r) => r.share),
  /** Creates the link (or returns the active one); `rotate` replaces it with a new one. */
  create: (projectId: string, rotate = false) =>
    apiFetch<{ share: ShareLink }>(path(projectId), {
      method: 'PUT',
      json: rotate ? { rotate } : {},
    }).then((r) => r.share),
  remove: (projectId: string) => apiFetch<undefined>(path(projectId), { method: 'DELETE' }),
  /** The shared project, for anyone with the link. Unvalidated: run it through `parseProject`. */
  read: (token: string) =>
    apiFetch<{ project: unknown; meta: { name: string; updatedAt: number } }>(
      `/shared/${encodeURIComponent(token)}`,
    ),
};

/** The public URL of a share link, optionally with a language and view state. */
export function shareUrl(
  origin: string,
  token: string,
  query: Record<string, string> = {},
): string {
  const search = new URLSearchParams(query).toString();
  return `${origin}/s/${token}${search ? `?${search}` : ''}`;
}
